/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryAddressCheckRequestSchema = z.object({
	address_id: z.uuid().optional().describe("Сохранённый адрес гостя вместо полей адреса."),
	city: z.string().max(60).optional(),
	entrance: z.string().max(10).optional(),
	line1: z.string().max(250).optional(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	cart_sum: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.nullish(),
	delivery_time: z.iso.datetime().nullish().describe("Время доставки в местном времени точки; пусто — как можно скорее."),
});
